require('babel-core/register')
require('babel-polyfill')

module.exports = {
  Inspector: require('./lib/Inspector'),
  putInspect: require('./lib/putInspect'),
  JSDoc: require('./lib/JSDoc')
}



//////////////////
// WEBPACK FOOTER
// ../index.js
// module id = 287
// module chunks = 0